module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Hansel&GretelWitchHunters.55d4dd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Hansel&GretelWitchHunters.jpg
// module id = +0CI
// module chunks = 0